// Utilidades para AutoNumeric > 4.0
export const ConfiguracionPrecio = {
  emptyInputBehavior: 'null',
  digitGroupSeparator: '.',
  decimalCharacter: ',',
  // Para que si dan al punto nos lo tome como que es la coma
  decimalCharacterAlternative: '.',
  minimumValue: '0.00',
  maximumValue: '9999999999.00',
  currencySymbol: ' €',
  currencySymbolPlacement: 's',
};

export const ConfiguracionInteger = {
  emptyInputBehavior: 'null',
  currencySymbol: '',
  digitGroupSeparator: '',
  decimalPlaces: 0,
  minimumValue: '0',
  maximumValue: '9999999999',
  leadingZero: 'allow',
  overrideMinMaxLimits: 'ceiling',
};

export const ConfiguracionDecimal = {
  ...ConfiguracionInteger,
  decimalPlaces: 2,
  decimalCharacter: ',',
  // Para que si dan al punto nos lo tome como que es la coma
  decimalCharacterAlternative: '.',
  overrideMinMaxLimits: 'ceiling',
};

export const ConfiguracionNota = {
  ...ConfiguracionDecimal,
  currencySymbol: '',
};

export const ConfiguracionPorcentaje = {
  emptyInputBehavior: 'null',
  digitGroupSeparator: '.',
  decimalCharacter: ',',
  minimumValue: '0',
  maximumValue: '100',
  currencySymbol: ' %',
  currencySymbolPlacement: 's',
};

export const Configuraciones = {
  entero: ConfiguracionInteger,
  decimal: ConfiguracionDecimal,
  porcentaje: ConfiguracionPorcentaje,
  precio: ConfiguracionPrecio,
  nota: ConfiguracionNota,
};
